import { render, staticRenderFns } from "./customer-messaging-options.vue?vue&type=template&id=abd91dc6"
import script from "./customer-messaging-options.vue?vue&type=script&lang=js"
export * from "./customer-messaging-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports